import type { FaireProductEntity } from "../../entity_types/product";

export const p_bm7tync8ep: FaireProductEntity = {
  token: "p_bm7tync8ep",
  type: "product",
  name: 'PEANUTS CLASSIC SNOOPY 5" PET BOWL, 116685 01A',
  brandToken: "b_gk6kg6d4dw",
  brandName: "JOIA ACCESSORIES",
  imageUrl:
    "https://cdn.faire.com/fastly/e2f2abbfc68165f5f2db13df7fe100b5a60fc4934cd089d678292377e2a601d1.jpeg",
  galleryImageUrls: [],
  priceDollars: 6.93,
  description:
    'PEANUTS CLASSIC SNOOPY 5" PET BOWL Peanuts Classic Snoopy 5" Pet Bowl - 6 Assorted Designs - Decorated - Stoneware - O/S',
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:38.497Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
